<template>
	<div class="book">
		<div class="book-content">
			<div class="book-list">
				<div class="book-listItem">
					<div class="book-listItemLabel">Услуга:</div>
					<div class="book-listItemContent">{{ params.name }}</div>
				</div>
				<div class="book-listItem">
					<div class="book-listItemLabel">Дата:</div>
					<div class="book-listItemContent">
						{{ params.day }} {{ params.month.declension.toLowerCase() }},
						{{ params.weekDay.name.toLowerCase() }}
					</div>
				</div>
				<div class="book-listItem">
					<div class="book-listItemLabel">Время:</div>
					<div class="book-listItemContent">{{ params.time }}</div>
				</div>
				<div class="book-listItem">
					<div class="book-listItemLabel">Длительность:</div>
					<div class="book-listItemContent">{{ params.duration }} мин.</div>
				</div>
				<div class="book-listItem" v-if="workers_id !== '0'">
					<div class="book-listItemLabel">Сотрудник:</div>
					<div class="book-listItemContent">{{ params.worker }}</div>
				</div>
				<div class="book-listItem">
					<div class="book-listItemLabel">Стоимость:</div>
					<div class="book-listItemContent">{{ service.price === '0.00' ? 'бесплатно' : price }}</div>
				</div>
				<div class="book-listItem" v-if="params.method">
					<div class="book-listItemLabel">Метод оплаты:</div>
					<div class="book-listItemContent">{{ params.method }}</div>
				</div>
				<div class="book-listItem" v-if="params.equipments_id.length > 1">
					<div class="book-listItemLabel">Оборудование:</div>
					<div class="book-listItemContent">{{ params.equipments_id.length }}</div>
				</div>
			</div>
			<quick-login v-if="!$store.state.user.id"></quick-login>
			<form class="form">
				<div class="form-control" v-if="subscriptions && subscriptions.length > 0">
					<label class="form-label">Абонемент</label>
					<v-select
						placeholder="Выберите абонемент из списка"
						label="fullName"
						:options="subscriptions"
						v-model="subscription"
					></v-select>
				</div>
				<div class="form-control" v-if="coupons && coupons.length > 0 && !subscription">
					<label class="form-label">Промокод</label>
					<v-select
						placeholder="Выберите промокод"
						label="fullName"
						:options="coupons"
						v-model="coupon"
					></v-select>
				</div>

				<div class="form-control">
					<label class="form-label">Ваш комментарий</label>
					<textarea v-model="comment" class="form-input" type="text" name="comment"></textarea>
				</div>

				<template v-if="!!$store.state.user.id">
					<div class="book-payMethod" v-if="!method">
						<h3>Выберите способ оплаты</h3>
						<div class="form-buttons row">
							<div class="form-buttonsItem row-item row-item_half">
								<div class="button" @click="method = 1"><span>Оплата онлайн</span></div>
							</div>
							<div class="form-buttonsItem row-item row-item_half">
								<div class="button2 button2_big" @click="method = 2">
									<span>Оплатить на месте</span>
								</div>
							</div>
						</div>
					</div>
					<div class="form-control text-center" v-else>
						<div class="form-buttons">
							<div class="form-buttonsItem">
								<div class="button" @click="submit"><span>Записаться на услугу</span></div>
							</div>
							<div class="form-buttonsItem" v-if="method && !prepay">
								<div class="button2 button2_big" @click="method = ''">
									<span>Сменить метод оплаты</span>
								</div>
							</div>
							<div class="form-buttonsText" v-if="prepay">
								Предоплата данной услуги обязательна
							</div>
						</div>
					</div>
				</template>
			</form>
		</div>
	</div>
</template>

<script>
import helper from '@/plugins/helper.js';
import quickLogin from './book/quickLogin.vue';
import _ from 'lodash';

export default {
	components: { quickLogin },
	props: {
		item: Object,
		type: {
			//тип расписания
			/*
				0 - список сеансов всех услуг с возможностью записи
				1 - список сеансов доступных к созданию в услуге
			*/
			default: '0',
		},
		workers_id: {
			//выбранный сотрудник
			default: '0',
		},
		equipments_id: {
			//выбранное оборудование
			default: () => [],
		},
		services_id: {
			//выбранная услуга
			default: '0',
		},
	},
	data() {
		return {
			method: null, //метод оплаты
			comment: '', //комментарий к записи
			subscription: null, //абонемент
			coupon: null, //промокод
		};
	},
	created() {
		if (this.prepay)
			//обязательная оплата на сайте (без оплаты на месте)
			this.method = '1';
	},
	computed: {
		hours() {
			let hours = Math.ceil(this.params.duration / 60);
			//стоимость при использовании оборудования
			if (this.subscription && this.equipments_id.length > 0) hours = hours * this.equipments_id.length;
			return hours;
		},
		price() {
			let price = this.params.price;
			if (this.subscription) {
				if (this.subscription.count > 0) {
					let uses = this.equipments_id.length ? this.equipments_id.length : 1;
					return (
						(uses === 1 ? '' : uses) +
						' ' +
						helper.inclean(String(uses), ['использование', 'использования', 'использований']) +
						' абонемента'
					);
				} else if (this.subscription.prepay > 0) {
					return (
						this.hours + ' ' + helper.inclean(String(this.hours), ['час', 'часа', 'часов']) + ' абонемента'
					);
				} else {
				}
			}
			return price + ' руб.';
		},
		service() {
			if (this.type === '0') {
				return this.item;
			}
			return _.find(this.$store.state.services.items, item => item.id === this.item.services_id);
		},
		subscriptions() {
			return _.filter(
				this.$store.getters['subscriptions/getUserSubscriptions'],
				item => item.status === '1' && item.state === '1' && item.categories_id === this.service.categories_id
			);
		},
		coupons() {
			return _.filter(this.$store.getters['user/getUserCoupons'], i => {
				if (!i.services.includes(this.service.id)) return false;
				if (+this.item.timestamp > +i.timestamp_end_booking) return false;
				return i.workers_id === '0' || i.workers_id === this.workers_id;
			});
		},
		params() {
			let methods = {
				'0': 'Не выбран',
				'1': 'Оплата онлайн',
				'2': 'Оплата на месте',
			};
			let date = new Date();
			date.setTime(this.item.timestamp * 1000);

			/* определение стоимости */
			let price = this.service.price;
			//стоимость услуги у выбранного сотрудника
			if (this.workers_id !== '0') price = this.service.prices[this.workers_id];
			//todo цена повторного оказания услуги
			//стоимость при использовании абонемента
			if (this.subscription) {
				price = 0;
			} else if (this.coupon) {
				price = Math.round(price * (100 - this.coupon.discount_perc)) / 100;
				price = price - this.coupon.discount_value;
			}
			if (price < 0) price = 0;
			//стоимость при использовании оборудования
			if (this.equipments_id.length > 0) price = price * this.equipments_id.length;

			return {
				id: this.item.id,
				services_id: this.services_id,
				workers_id: this.workers_id,
				date: date,
				timestamp: this.item.timestamp,
				equipments_id: this.equipments_id,
				name: this.item.name,
				time: helper.timeFormat(date.getHours() * 60 + date.getMinutes()),
				day: date.getDate(),
				weekDay: helper.getWeekDay(date),
				month: helper.getYearMonth(date),
				duration: this.item.duration,
				worker: this.item.wname + ' ' + this.item.surname,
				method: methods[this.method],
				method_id: this.method,
				comment: this.comment,
				price: helper.priceFormat(price),
				subscriptions_id: this.subscription ? this.subscription.id : null /* deprecated */,
				subscriptions_clients_id: this.subscription ? this.subscription.subscriptions_clients_id : null,
				coupons_id: this.coupon ? this.coupon.id : null,
			};
		},
		prepay() {
			let time = this.params.date.getHours() * 60 + this.params.date.getMinutes();
			return (
				this.service.prepay === '1' ||
				(this.service.prepay === '0' &&
					!(time >= +this.service.prepay_start && time < +this.service.prepay_end))
			);
		},
	},
	methods: {
		submit() {
			this.$store
				.dispatch('api/send', {
					task: 'book',
					data: this.params,
				})
				.then(() => {
					this.$router.push('/current');
				});
		},
	},
	watch: {
		subscription() {
			if (this.subscription) {
				let uses;
				if (this.subscription.count > 0) {
					//если по чисту использований
					uses = this.equipments_id.length ? this.equipments_id.length : 1;
					if (this.subscription.client_count < uses) {
						this.subscription = '';
						helper.notice({
							title: 'Не подходящий абонемент',
							text: 'Недостаточно предоплаченных единиц для использования данного абонемента',
						});
					}
				}

				if (this.subscription.prepay > 0) {
					//если по предоплаченным часам
					uses = this.hours;
					if (this.subscription.client_prepay < uses) {
						this.subscription = '';
						helper.notice({
							title: 'Не подходящий абонемент',
							text: 'Недостаточно предоплаченных часов для использования данного абонемента',
						});
					}
				}
			}
		},
	},
};
</script>
